<template lang="pug">
  .lei-link(:class="classes")
    font-awesome-icon.lei-link__hover-pointer(v-if="withChallenge" icon="arrow-right")
    slot(name="prepend")
    slot(name="link")
      router-link.link(:to="to")
        slot
    .lei-link__link-filler
    el-tooltip(popper-class="lei-tooltip", effect="dark", :content="tooltip", placement="top")
      font-awesome-icon.icon(v-if="showIcon" icon="link", @click="$emit('more')" :class="customStyle")
    font-awesome-icon.icon(v-if="withChallenge" icon="edit" @click="openLinksChallenge")
    lei-popover(:text="tip")
      slot(name="append")
</template>
<script>
import LeiPopover from './LeiPopover'
import LeiBtn from '@/components/lei-components/LeiBtn'

export default {
  components: {
    LeiBtn,
    LeiPopover,
  },
  props: {
    tooltip: {
      type: String,
      default: 'Show Relationship Data',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'default',
    },
    to: {
      type: Object,
      required: true,
    },
    withChallenge: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: Object,
      default: () => ({
        small: '',
        full: '',
      }),
    },
    customColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    classes () {
      let classes = []
      if (!this.custom) {
        classes.push(this.type)
      }
      return classes.length > 0 ? classes : ''
    },
    customStyle () {
      return this.customColor ? this.customColor.toLowerCase() : ''
    },
  },
  methods: {
    openLinksChallenge () {
      let challengeTo = this.to.params ? {
        name: 'Challenge',
        params: this.to.params,
      } : null

      this.$confirm('You are leaving the current record.', {
        type: 'warning',
      }).then(() => {
        this.$router.push(challengeTo)
      }).catch(() => {
        // do nothing
      })
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .lei-link
    display flex
    align-items center

    &__link-filler
      flex-grow 1

    &__hover-pointer
      display none

    &.default
      .link
        cursor pointer
        line-height 1.25rem
        color $default-color-bold
        border-bottom 1px solid $info-color
        transition all .2s ease
        &:hover
          color $primary-color
          border-bottom 1px solid $primary-color
      .icon
        cursor pointer
        margin  0 10px
        font-size 125%
        color $primary-color-light-5
        transition all .2s ease
        &:hover
          color $primary-color

  .published
    color: $info-color !important

  .lapsed
    color: $danger-color !important

  @media (min-width:$mobile)
    .lei-link
      &__link-filler
        flex-grow 0

    @media (min-width:$tablet)
      .lei-link
        &__hover-pointer
          display block
          margin 0 5px 0 0
          opacity 0
          transform: translateX(-10px)
          transition all .5s ease

        &:hover
          .lei-link__hover-pointer
            opacity 1
            transform: translateX(0)
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiLink.vue